import React, { useState, useEffect } from "react";
import { Form } from "semantic-ui-react";
import { get, map } from "lodash";
import PropTypes from "prop-types";
import Text from "@Components/Text";
import IKModal from "@Components/IkModal";
import styles from "./styles.module.css";

const NotaModal = ({ tags, initialNotas = {}, onClose, onConfirm }) => {
	const [notas, setNotas] = useState(() => {
		const initial = {};
		map(tags, (tag) => {
			initial[tag.id] = initialNotas[tag.id] || "";
		});
		return initial;
	});

	useEffect(() => {
		setNotas((prev) => {
			const updated = { ...prev };
			map(tags, (tag) => {
				if (!(tag.id in updated)) {
					updated[tag.id] = initialNotas[tag.id] || "";
				}
			});
			return updated;
		});
	}, [tags]);

	const handleChange = (tagId, value) => {
		setNotas((prev) => {
			return { ...prev, [tagId]: value };
		});
	};

	const handleConfirm = () => {
		const result = map(tags, (tag) => {
			return { tagId: tag.id, nota: notas[tag.id] || "" };
		});
		onConfirm(result);
	};

	return (
		<IKModal title="Nota de Etiquetas" onClose={onClose} onSuccess={handleConfirm} size="tiny">
			<div className={styles.div}>
				<fieldset className={styles.fieldset}>
					{map(tags, (tag, index) => {
						return (
							<div key={tag.id} className={styles.notaField}>
								{index > 0 && <hr style={{ border: "none", borderTop: "1px solid #c3c6cf", margin: "10px 0" }} />}
								<div className={styles.textTyle}>{get(tag, "name", "")}:</div>
								<Form>
									<div className={styles.rowTitleImg}>
										<Text className={styles.textArea}> Nota: </Text>
									</div>
									<Form.TextArea
										value={notas[tag.id] || ""}
										onChange={(e) => {
											return handleChange(tag.id, e.target.value);
										}}
										className={styles.input}
										fluid
										placeholder="Escribe aqui..."
									/>
								</Form>
							</div>
						);
					})}
				</fieldset>
			</div>
		</IKModal>
	);
};

NotaModal.propTypes = {
	tags: PropTypes.array.isRequired,
	initialNotas: PropTypes.object,
	onClose: PropTypes.func.isRequired,
	onConfirm: PropTypes.func.isRequired,
};

export default NotaModal;
